module.exports = __webpack_public_path__ + "img/nav.6078429e.svg";